import { AppRootStateType } from 'state/store';

export const doctorsSelect = (state: AppRootStateType) => state.doctors.doctors;
export const choosedUserSelect = (state: AppRootStateType) => state.users.user;
export const userLoadingSelect = (state: AppRootStateType) => state.users.isLoading;
export const doctorVisitsSelect = (state: AppRootStateType) => state.doctors.visits;
export const doctorFinancesSelect = (state: AppRootStateType) => state.doctors.finances;
export const doctorSelect = (state: AppRootStateType) => state.doctors.doctor;

/** Providers awaiting admin approval. The count drives the sidebar badge. */
export const pendingProvidersCountSelect = (state: AppRootStateType) =>
  state.doctors.pendingCount;
export const pendingProvidersSelect = (state: AppRootStateType) =>
  state.doctors.pendingProviders;
export const isDecidingProviderSelect = (state: AppRootStateType) =>
  state.doctors.isDeciding;

/** Providers whose submitted photo is awaiting a decision. */
export const pendingPhotosCountSelect = (state: AppRootStateType) =>
  state.doctors.pendingPhotoCount;
export const pendingPhotosSelect = (state: AppRootStateType) =>
  state.doctors.pendingPhotos;
export const isDecidingPhotoSelect = (state: AppRootStateType) =>
  state.doctors.isDecidingPhoto;

/**
 * Why the last approval or photo decision was refused.
 *
 * Shared by the two cards: they are never in flight at once, since the
 * approval card only renders while the provider is pending and a pending
 * provider's photo is decided with the application rather than separately.
 */
export const decisionErrorSelect = (state: AppRootStateType) =>
  state.doctors.decisionError;
